import { useQuery } from 'react-query';
import { useSetRecoilState } from 'recoil';

import { createHttpClient } from '@api/http-client';
import { END_POINTS } from '@constants/api-endpoints';
import { QUERY_KEYS } from '@constants/query-keys';
import { AlertType } from '@enums/alert';
import { showAlert } from '@lib/alert/alert-manager';
import { userProfileAtom } from '@store/atoms/user';

import { User } from './types';

export const useGetUser = ({
  enabled = true,
}: {
  enabled?: boolean;
} = {}) => {
  const client = createHttpClient();

  const setCurrentUser = useSetRecoilState(userProfileAtom);

  const query = useQuery(
    QUERY_KEYS.USER.GET_USER_DETAILS,
    () => {
      return client<User>({
        url: END_POINTS.USER.GET_USER_DETAILS,
      });
    },
    {
      retry: 0,
      enabled,
      onSuccess: data => {
        setCurrentUser(data);
      },
      onError: (error: Error) => {
        showAlert({
          type: AlertType.ERROR,
          header: 'Failed to fetch user details',
          message: `${error?.message || 'Request failed'}`,
        });
      },
    },
  );

  return query;
};
